"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var resource_1 = require("./resource");
var resource = "umprn";
exports.create = function (client) {
    var retrieve = resource_1.retrieveMethod({ resource: resource, client: client });
    return { retrieve: retrieve };
};
//# sourceMappingURL=umprn.js.map